<template>  
    <v-main>  
      <v-container fill-height>  
        <v-layout align-center justify-center>  
            <v-card-text>  
              <div class="text-center mt-16">
                <!-- 完成图标 -->  
                <v-icon size="100" color="success" class="mb-4">mdi-check-circle</v-icon>  
                
                <!-- 完成标题 -->  
                <h2 class="text-h4 mb-2 mt-16 font-weight-bold">完成</h2>  
                
                <!-- 数据完成提交标题(可进行附加跳转链接) -->  
                <p class="text-body-1 mb-4">您的填报 <a>点检记录 </a>已完成提交！</p>  
                <div>
                <!-- 按钮区域 -->  
                <div class="mt-16">  
                  <!-- 继续填报按钮 -->  
                  <v-btn color="success" text @click="$router.push('/AbnormalHome')" style="border: 1px rgb(191,196,200) solid; width: 200px; font-size:medium;">继续填报</v-btn>  
                </div>
                  <!-- 完成按钮 -->  
                  <div>
                  <v-btn class="mt-4" color="primary" elevation="0" @click="$router.push('/home')" style="border: 1px rgb(50,134,218) solid; width: 200px; font-size:medium;">完成</v-btn>  
                </div> 
                </div>
              </div>  
            </v-card-text> 
        </v-layout>  
      </v-container>  
    </v-main>  
  </template>  
  
  <script>  
  export default {  
    name: "logo",  
    methods: {  
    //   创建函数点击事件进行页面路由的跳转处理  
    //   goToFillReport() {  
    //     this.$router.push("/abnormal");  
    //   },  
    //   // 跳转到首页  
    //   goToHome() {  
    //     this.$router.push("/");  
    //   },  
    },  
  };  
  </script>  